'use client';

import React, { useState } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { LuChevronDown } from 'react-icons/lu';
const CARD_EXPAND_TRANSITION = {
  height: {
    duration: 0.28,
    ease: [0.32, 0.72, 0, 1]
  },
  opacity: {
    duration: 0.2,
    ease: 'easeOut'
  }
};
export function InterviewRoundCardShell({
  title,
  status,
  description,
  meta,
  participants,
  detailsIcon,
  detailsTitle = 'Details',
  detailsActions,
  timeLabel,
  children
}) {
  const [expanded, setExpanded] = useState(false);
  const toggle = () => setExpanded(v => !v);
  return <div>
            <div className="bg-page rounded-xl border border-border flex flex-col w-full min-w-[280px] sm:min-w-[360px] md:min-w-[420px] lg:min-w-[500px] overflow-hidden transition-shadow">
                <div role="button" tabIndex={0} onClick={toggle} onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      }} className="px-4 py-3 cursor-pointer hover:bg-muted/30 text-left">
                    <div className="flex items-center justify-between gap-2 flex-wrap mb-1">
                        <span className="text-base font-bold text-foreground">{title}</span>
                        {status}
                    </div>
                    {description ? <p className="text-sm text-foreground-muted mb-1">{description}</p> : null}
                    {meta}
                    <div className="flex items-center justify-between gap-3 flex-wrap mt-4">
                        {participants}
                        <span className="inline-flex items-center gap-1 text-xs font-semibold text-foreground-muted">
                            {expanded ? 'View Less' : 'View More'}
                            <motion.span animate={{
              rotate: expanded ? 180 : 0
            }} transition={{
              duration: 0.2
            }} className="inline-flex">
                                <LuChevronDown className="w-4 h-4" />
                            </motion.span>
                        </span>
                    </div>
                </div>

                <AnimatePresence initial={false}>
                    {expanded ? <motion.div key="body" initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={CARD_EXPAND_TRANSITION} className="overflow-hidden">
                            <div onClick={e => e.stopPropagation()}>
                                <div className="flex items-center justify-between px-4 py-2 bg-muted">
                                    <div className="flex items-center gap-2">
                                        {detailsIcon}
                                        <span className="text-sm font-bold text-foreground">{detailsTitle}</span>
                                    </div>
                                    {detailsActions ? <div className="flex items-center gap-1.5">{detailsActions}</div> : null}
                                </div>
                                {children}
                            </div>
                        </motion.div> : null}
                </AnimatePresence>
            </div>

            <div className="flex items-center justify-between gap-2 pt-2 pl-5">
                <span className="text-xs text-foreground-subtle">{timeLabel}</span>
            </div>
        </div>;
}